export default "__VITE_ASSET__D0WcgU9Q__"